<template>
  <section id="head-box">
    <div class="container NoSelect" :style="{display:isshow}">
    	<div class="logo">
        <a target="_blank" href="https://exshopee.cn"><img src="../../../static/images/logo-.png"></a>
        <div class="left_open">
        	<i title="展开左侧栏" class="fa" :class="icon" v-on:click="drawerFun"></i>
        </div>
      </div>
      <div class="head-nav">
      	<ul>
          <li v-for="item in navList" :class="{'head-nav-active':item.active}" v-text="item.title" v-on:click="NavSwitch(item.title)"></li>
        </ul>
      </div>
    	<ul class="layui-nav right">
    		<li class="layui-nav-item">
    			<a href="javascript:;">
            <i class="userinfo" v-text="username"></i>
            <i v-text="usertype"></i>
    				<span class="layui-nav-more"></span>
    			</a>
    			<dl class="layui-nav-child">
    				<dd v-on:click="ShowChangePwd"><a>修改密码</a></dd>
    				<dd><a v-on:click="Logout">退出</a></dd>
    			</dl>
    		</li>
    	</ul>

      <!-- loading -->
      <K-Loading v-if="loading"></K-Loading>

      <!-- toast -->
      <K-Toast :Toast="Toast" @ChangeToast="ChangeToast"></K-Toast>

    </div>
  </section>
</template>

<script>
var self,form,layer,element,username,moduleXml;
import axios from 'axios'
import Loading from '@/components/common/Loading.vue'
import Toast from '@/components/common/Toast.vue'
export default {
  name: 'HeadBar',
  components: {
    'K-Loading': Loading,
    'K-Toast': Toast,
  },
  data () {
    return {
      uid:null,
      isshow:"block",
      username : localStorage.getItem("ExShopee_UserName"),
      loading: false,
      Toast:{
        state: false,
        type: 0,
        txt: null
      },
      navList:[],
			drawer: true,
      usertype:"「 免费用户 」",
			icon: "fa-fast-backward",
      isNone:["Login","Bulk","BulkGlobal","Authorization","Print"],
      version:["Order","Col","Product","Global"]
    }
  },
  watch:{
      $route:{
        handler(nv,ov){
          if(self.isInArray(self.isNone,self.$route.name)){
            self.isshow = "none";
          }else{
            self.isshow = "block";
          }

          if(ov.name == "Login"){
            self.NavData();
            if(localStorage.getItem("ExShopee_Role") == 30){
              self.username = localStorage.getItem("ExShopee_UserName")
            }else{
              self.username = localStorage.getItem("ExShopee_NickName")
            }
          }

          //上述页面内置检测
          if(!self.isInArray(self.version,self.$route.name)){
            self.VersionCheck(); //版本检测
          }

        }
      },
      deep:true
  },
  mounted () {
    self = this;
    self.uid = localStorage.getItem("ExShopee_id");
    if(localStorage.getItem("ExShopee_Role") == 30){
      self.username = localStorage.getItem("ExShopee_UserName")
    }else{
      self.username = localStorage.getItem("ExShopee_NickName")
    }
    if(self.isInArray(self.isNone,self.$route.name)){
      self.isshow = "none";
    }else{
      self.isshow = "block";
    }
    self.NavData();

    layui.use(['form','element', 'layer'], function() {
      form = layui.form;
    	element = layui.element;
      layer = layui.layer;
      self.GetUserPackage();
    });

    //监听
    this.$bus.$on('watchNavSwitch',function(e){
      self.NavSwitch(e);
    })
    
  },
  methods:{
    ToastFun (type,txt) {
      self.Toast.state = true;
      self.Toast.type = type;
      self.Toast.txt = txt;
    },
    ChangeToast () {
      self.Toast.state = false;
    },
    drawerFun () {
    	var _this = this;
    	if (_this.drawer) {
    		_this.drawer = false;
    		_this.icon = "fa-fast-forward";
        $('.pagebox').animate({
        	paddingRight: '0px'
        }, 0);
    		$('.left-nav').animate({
    			left: '-220px'
    		}, 100);
    		$('.page-content,.page-box').animate({
    			left: '0px'
    		}, 100);
    	} else {
    		_this.drawer = true;
    		_this.icon = "fa-fast-backward";
        $('.pagebox').animate({
        	paddingRight: '220px'
        }, 0);
    		$('.left-nav,.page-box').animate({
    			left: '0px'
    		}, 100);
    		$('.page-content,.page-box').animate({
    			left: '220px'
    		}, 100);
    	}
    },
    Logout () {
      self.loading = true;
      axios({
        method: 'post',
        url: self.GetServerUrl() + "/logout_view/",
      }).then(function(response) {
        self.loading = false;
        var json = response.data;
        self.ClearStorage();
        window.location.href = self.GetServerLink();
      }).catch(function(error) {
        self.loading = false;
        self.ClearStorage();
        window.location.href = self.GetServerLink();
        self.ToastFun(2,error);  //弹窗提醒
      })
    },
    ClearStorage () {
      localStorage.removeItem("ExShopee_id");
      localStorage.removeItem("ExShopee_Role");
      localStorage.removeItem("ExShopee_token");
      localStorage.removeItem("ExShopee_UserName");
    },
    NavData () {
      var role = localStorage.getItem("ExShopee_Role");
      var nav = [{
          active:false,
          title:"货代",
        },{
          active:false,
          title:"上架",
        },{
          active:false,
          title:"管理",
        },{
          active:false,
          title:"数据",
        },{
          active:false,
          title:"教程",
        }];
      if(role == "10"){
        nav.splice(2,0,{active:false,title:"金融"});
        self.navList = nav;
      }else if(role == "20"){
        nav.splice(1,3);
        self.navList = nav;
      }else{
        self.navList = nav;
      }
      self.NavSwitch();
    },
    NavSwitch (name) {
      self.$emit('UpdateHead');
      if(name){
        if(name == "数据"){
          layer.msg("功能暂未开放！");
          return;
        }else if(name == "教程"){
          window.open("https://exshopee.cn/document.html")
          return;
        }
        for(let i in self.navList){
          if(self.navList[i].title == name){
            self.navList[i].active = true;
          }else{
            self.navList[i].active = false;
          }
        }
        localStorage.setItem("ExShopee_Sort",name);
      }else{
        setTimeout(function(){
          if(localStorage.getItem("ExShopee_Sort")){
            self.NavSwitch(localStorage.getItem("ExShopee_Sort"));
          }else{
            self.NavSwitch("货代");
          }
        },100)
      }

    },
    VersionCheck () {
      axios({
        method: 'post',
        url: self.GetServerUrl() +"/version/",
        headers: {
          'token': localStorage.getItem("ExShopee_token")
        }
      }).then(function(res) {
        var json = res.data;
        if(json.code == 200){
          if(json.datas.version != localStorage.getItem("ExShopee_Version")){
            localStorage.setItem("ExShopee_Version",json.datas.version);
            window.location.reload(true);
          }
        }
      }).catch(function(error) {
        console.log(error);
      })
    },
    GetUserPackage () {
      let param = new URLSearchParams()
      axios({
        method: 'post',
        url: self.GetServerUrl() +"/user_package/",
        data: param,
        headers: {
          'token': localStorage.getItem("ExShopee_token")
        }
      }).then(function(response) {

        //返回数据处理
        self.ReturnFuntion(self, response, function(datas) {
          if(datas.is_buy == 1){
            self.usertype = "「 VIP用户 」"
          }
        }, false, true);

      }).catch(function(error) {
        console.log(error);
      })
    },
    ShowChangePwd () {
      var w, h;
      if (w == null || w == '') {
        w = $(window).width() - 260;
        if(w > 500){
          w = 500;
        }
      };
      if (h == null || h == '') {
        h = $(window).height() - 200;
        if(h > 410){
          h = 350;
        }
      };
      let l = $(window).width()/2 - w/2 - 220;
      moduleXml = layer.open({
        type: 1,
        offset: ['75px', l+'px'],
        title: "修改密码",
        area: [w + 'px', h + 'px'],
        fixed: false, //不固定
        btn: ['确定'],
        content: ChangePwdHtml,
        success: function() {

          form.render();
        },
        yes: function(index, layero) {
          var password = $("#password").val();
          var newpassword = $("#newpassword").val();
          var repassword = $("#repassword").val();
          if(!password){
            layer.msg("旧密码不能为空！");
            return;
          }
          if(!newpassword){
            layer.msg("新密码不能为空！");
            return;
          }
          if(!repassword){
            layer.msg("重复密码不能为空！");
            return;
          }

          let param = new URLSearchParams()
          param.append('password', password)
          param.append('newpassword', newpassword)
          param.append('repassword', repassword)

          self.loading = true;
          axios({
            method: 'post',
            url: self.GetServerUrl() + "/change_pwd/",
            data: param,
            headers: {
              'token': localStorage.getItem("ExShopee_token")
            }
          }).then(function(response) {
            layer.msg(response.data.msg);

            //返回数据处理
            self.ReturnFuntion(self, response, function(datas) {
              layer.close(moduleXml);
            }, false);

          }).catch(function(error) {
            self.loading = false;
            layer.msg("修改失败，请稍后再试！");
          })

        }
      });
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.logo a{
  display: block;
  height: 100%;
}
.logo:hover{
  opacity: 0.85;
}.head-nav{
  float: left;
}
.head-nav ul{
  overflow: hidden;
}
.head-nav ul li{
  color: #FFF;
  float: left;
  width: 85px;
  font-size: 15px;
  text-align: center;
  line-height: 55px;
  cursor: pointer;
  color: rgba(255, 255, 255, .7);
}
.head-nav ul li:hover{
  background-color: #212121;
}
.head-nav-active{
  color: #FFF !important;
  background-color: #282b33 !important;
}
</style>



// WEBPACK FOOTER //
// src/components/common/HeadBar.vue